import styles from '@/app/assets/components/upload/atoms/styles.module.css';
import { Stack, Text } from '@mantine/core';
import Image from 'next/image';
import { Dropzone, FileWithPath } from '@mantine/dropzone';
import { useState } from 'react';
import { showErrorNotification } from '@/app/components/shared/notifications';
import { useHover } from '@mantine/hooks';

type AssetsDropzoneProps = {
  onFileDropped: (files: FileWithPath[]) => void;
  disabled: boolean;
  errorNotificationMessage?: string;
};

export default function AssetsDropzone({
  onFileDropped,
  disabled,
  errorNotificationMessage = "You can't add new files, when upload is pending!",
}: AssetsDropzoneProps) {
  const [isDraggedOver, setIsDraggedOver] = useState(false);
  const dragOverColor = disabled ? 'red.1' : 'green.1';
  const { ref, hovered } = useHover();

  return (
    <Dropzone
      ref={ref}
      onDragLeave={() => setIsDraggedOver(false)}
      onDragEnter={() => setIsDraggedOver(true)}
      onDrop={(e) => {
        setIsDraggedOver(false);
        if (disabled) {
          return showErrorNotification({ message: errorNotificationMessage });
        }
        onFileDropped(e);
      }}
      style={{ cursor: hovered ? 'pointer' : undefined }}
    >
      <Stack
        className={`rounded-[20px] bg-[#F8F9FA] ${styles.dashedBorder}`}
        align='center'
        style={{ pointerEvents: 'none' }}
        justify='center'
        p='lg'
        bg={isDraggedOver ? dragOverColor : undefined}
      >
        <Image src='/upload/dropzone-icon.svg' alt='Dropzone logo' width={130} height={45} />
        <Text c='dark.2' className='text-center'>
          <Text fw={600} td='underline' span={true}>
            Select
          </Text>
          <Text span={true}> or </Text>
          <Text td='underline' span={true}>
            drag & drop
          </Text>{' '}
          files here to process your own assets.
        </Text>
      </Stack>
    </Dropzone>
  );
}
